import React from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ImageEffectPlugin } from '../controller';
import { useImageEffectState } from '../states/image-effect-state';

/** 图片特效外部面板挂载点；图层画面统一由图片图层 render 输出。 */
export const ImageEffectPanelHost: React.FC = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const { originLayer, currentLayer } = useImageEffectState()((state) => state);
    const controller = framework.service.registration.getInstance<ImageEffectPlugin>('ImageEffectPlugin');
    const panel = controller.getPanel();

    if (!originLayer || !currentLayer) return null;

    return <>{panel}</>;
});
